import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsMission } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";

export default function MissionView() {
  const {id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [paraData, setParaData] = useState({});

  const fetchTitle = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return
    };
    try {
      const response = await getAboutUsMission(id);
      console.log(response.data);
        const paragraphData = response.data.data[0];
        setParaData({...paragraphData,...paragraphData,index:response.data.data.indexOf(paragraphData)})
      // setPara(response.data.data[0].paragraph);
    } catch (error) {
      console.error(error);
    }finally{
        setIsLoading(false);
      };
  };

  useEffect(() => {
    fetchTitle();
  }, [id]);


  const columns = ["Part Name", "Content"];
  const rows = [];
  if (paraData && Object.keys(paraData).length > 0) {
    rows.push(['Mission Paragraph', paraData.paragraph]);
  }
  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      {/* Title */}
      <HomeTitle>Mission Section</HomeTitle>
      <CustomTable columns={columns} rows={rows}/>
      {/* Table */}

      {/* Button section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/mission/edit/${id}`}
        >
          <Button>{Number(id) ? 'Edit' : 'Add'} Paragraph Section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;





const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
     @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
